import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/auth/LoginPage';
import UploadItems from './pages/UploadItems';
import Products from './pages/Products';
import Reconciliation from './pages/Reconciliation';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import { AuthProvider } from './context/AuthContext';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<LoginPage />} />
          
          {/* Protected Routes - Wrapped in Layout */}
          <Route path="/upload" element={
            <ProtectedRoute>
              <Layout>
                <UploadItems />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/products" element={
            <ProtectedRoute>
              <Layout>
                <Products />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/reconciliation" element={
            <ProtectedRoute>
              <Layout>
                <Reconciliation />
              </Layout>
            </ProtectedRoute>
          } />

          {/* Redirect root to upload if authenticated, otherwise to login */}
          <Route path="/" element={
            localStorage.getItem('user') ? 
            <Navigate to="/upload" replace /> : 
            <Navigate to="/login" replace />
          } />
          
          {/* Redirect any unknown routes */}
          <Route path="*" element={
            <Navigate to="/" replace />
          } />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
